<app-nav-bar></app-nav-bar>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h1>Contact Us</h1>
    </div>
  </div>
  <div class="flex align-center contact_us">
    <div class="contact_image-container">
      <img src="assets/images/contact-us.svg" alt="" />
    </div>
    <div class="contact_form-container">
      <form
        class="contact_form"
        [formGroup]="contactForm"
        (ngSubmit)="onSubmit()"
      >
        <div class="form-group">
          <input
            type="text"
            placeholder="First Name"
            class="add_field"
            formControlName="FirstName"
            [ngClass]="{
              'is-invalid':
                contactForm.controls.FirstName.invalid &&
                (contactForm.controls.FirstName.touched ||
                  contactForm.controls.FirstName.dirty)
            }"
          />
          <ng-container
            *ngIf="
              contactForm.controls.FirstName.invalid &&
              (contactForm.controls.FirstName.touched ||
                contactForm.controls.FirstName.dirty)
            "
          >
            <p
              *ngIf="contactForm.controls.FirstName.errors?.required"
              class="input-error"
            >
              First Name is required
            </p>
            <p
              *ngIf="contactForm.controls.FirstName.hasError('invalidName')"
              class="input-error"
            >
              Invalid First Name
            </p>
          </ng-container>
        </div>
        <div class="form-group">
          <input
            type="text"
            placeholder="Last Name"
            class="add_field"
            formControlName="LastName"
            [ngClass]="{
              'is-invalid':
                contactForm.controls.LastName.invalid &&
                (contactForm.controls.LastName.touched ||
                  contactForm.controls.LastName.dirty)
            }"
          />
          <ng-container
            *ngIf="
              contactForm.controls.LastName.invalid &&
              (contactForm.controls.LastName.touched ||
                contactForm.controls.LastName.dirty)
            "
          >
            <p
              *ngIf="contactForm.controls.LastName.errors?.required"
              class="input-error"
            >
              Last Name is required
            </p>
            <p
              *ngIf="contactForm.controls.LastName.hasError('invalidName')"
              class="input-error"
            >
              Invalid Last Name
            </p>
          </ng-container>
        </div>
        <div class="form-group">
          <input
            type="text"
            placeholder="Email Address"
            class="add_field"
            formControlName="Email"
            [ngClass]="{
              'is-invalid':
                contactForm.controls.Email.invalid &&
                (contactForm.controls.Email.touched ||
                  contactForm.controls.Email.dirty)
            }"
          />
          <ng-container
            *ngIf="
              contactForm.controls.Email.invalid &&
              (contactForm.controls.Email.touched ||
                contactForm.controls.Email.dirty)
            "
          >
            <p
              *ngIf="contactForm.controls.Email.errors?.required"
              class="input-error"
            >
              Email is required
            </p>
            <p
              *ngIf="contactForm.controls.Email.hasError('invalidEmail')"
              class="input-error"
            >
              Invalid email
            </p>
            <p
              *ngIf="
                contactForm.controls.Email.hasError('maxlength') &&
                !contactForm.controls.Email.hasError('invalidEmail')
              "
              class="input-error"
            >
              Email maxlength is 40.
            </p>
          </ng-container>
        </div>
        <div class="form-group">
          <textarea
            rows="4"
            cols="50"
            type="text"
            placeholder="Message"
            class="add_field"
            placeholder="Enter Message"
            formControlName="Message"
            [ngClass]="{
              'is-invalid':
                contactForm.controls.Message.invalid &&
                (contactForm.controls.Message.touched ||
                  contactForm.controls.Message.dirty)
            }"
          ></textarea>
          <ng-container
            *ngIf="
              contactForm.controls.Message.invalid &&
              (contactForm.controls.Message.touched ||
                contactForm.controls.Message.dirty)
            "
          >
            <p
              *ngIf="contactForm.controls.Message.errors?.required"
              class="input-error"
            >
              Message is required
            </p>
          </ng-container>
        </div>
        <div class="btn_bottom_sign">
          <button type="submit" class="button_btm">Send Message</button>
        </div>
      </form>
    </div>
  </div>
</div>
